import React, { useEffect, useRef, useState } from 'react';
import Image from 'next/image';
import classNames from 'classnames';
import { map } from 'lodash-es';
import './index.less';

const SupplierProfileSection = () => {
  const [isInView, setIsInView] = useState<boolean>(false);

  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => setIsInView(entry.isIntersecting));
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const listItems: string[][] = [
    [
      'AI-powered competitive intelligence',
      'Real-time social listening & monitoring',
      'Automated content creation at scale',
      'Influencer identification & management',
    ],
    [
      'Access 40,000+ global suppliers',
      'Pre-negotiated pricing & freight rates',
      'Integrated fulfillment infrastructure',
      'Integrates with your commerce stack',
    ],
  ];
  return (
    <div className="supplier-profile-section">
      <div className="content-max">
        <div className="features">
          <h2 className="title">Everything commerce teams need to operate at scale</h2>
          <div className="feature-list">
            {map(listItems, (section: string[], i: number) => {
              return (
                <div key={`feature-list-section-${i}`} className="feature-list-section">
                  {map(section, (item: string, j: number) => {
                    return (
                      <div key={`feature-list-item-${j}`} className="feature-list-item">
                        <Image
                          src="/images/homepage-v2/check-circle-spark.svg"
                          width={24}
                          height={24}
                          alt="New product development"
                        />
                        <p>{item}</p>
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>

          <div ref={ref} className={classNames('image', { 'in-view': isInView })}>
            <Image
              width={975}
              height={634}
              alt="Supplier Profile"
              loading="lazy"
              src="https://static.pietrastudio.com/public/file_uploads/166a079d3935d79509854be80bfaf832.png"
              sizes="auto, (min-width: 768px) 600px,(min-width: 1024px) 873px,(min-width: 1280px) 975px, 600px"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupplierProfileSection;
